import { AssetOverview } from '../components/AssetOverview'

export function Assets() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Assets</h1>
        <p className="text-eve-muted text-sm">
          Todos tus hangares en una sola vista: NPC stations, player
          structures, todo. Valor estimado en Jita para cada uno.
        </p>
      </div>

      <AssetOverview />
    </div>
  )
}
